import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';

import { getAdminDashboard } from 'helpers/api/temples';

import {
    templeAnalyticsApiResponseSuccess,
    templeAnalyticsApiResponseError,
} from './actions';

import { TempleAnalyticsActionTypes } from './constants';

/**
 * Get Admin Dashboard
 */
function* getAdminDashboardSaga({ payload }: any): SagaIterator {
    try {
        const response = yield call(getAdminDashboard, payload);

        yield put(
            templeAnalyticsApiResponseSuccess(
                TempleAnalyticsActionTypes.GET_ADMIN_DASHBOARD,
                response.data
            )
        );
    } catch (error: any) {
        yield put(
            templeAnalyticsApiResponseError(
                TempleAnalyticsActionTypes.GET_ADMIN_DASHBOARD,
                error
            )
        );
    }
}

/**
 * Watchers
 */
export function* watchGetAdminDashboard() {
    yield takeLatest(
        TempleAnalyticsActionTypes.GET_ADMIN_DASHBOARD,
        getAdminDashboardSaga
    );
}

/**
 * Root Saga
 */
function* templeAnalyticsSaga() {
    yield all([
        fork(watchGetAdminDashboard),
    ]);
}

export default templeAnalyticsSaga;